import { withAPIAccount } from '../../lib/http/api';
import { parsedResponse } from '../../lib/http/http';
import { AccountType, IAPIresponse } from '../../model';
import { IAccessToken } from '../../model/api-modules';
import { TOKEN_PROXY_PREFIX } from '../config';
// access token生成
export const createAccessToken = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${TOKEN_PROXY_PREFIX}/api/user/secret/access-token`;
      const response = await api.commonRequest('POST', url);
      const res = await parsedResponse<IAccessToken>(response, 'data');
      return res;
    } catch (error: any) {
      console.log('failed: createAccessToken', error);
      return null;
    }
  });
// access token获取
export const getAccessToken = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${TOKEN_PROXY_PREFIX}/api/user/secret/access-token`;
      const response = await api.commonRequest('GET', url);

      const res = await parsedResponse<IAccessToken>(response, 'data');
      return res;
    } catch (error) {
      console.log('failed: getAccessToken', error);
      return null;
    }
  });
// access token删除
export const deleteAccessToken = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${TOKEN_PROXY_PREFIX}/api/user/secret/access-token`;
      const response = await api.commonRequest('DELETE', url);
      const res = await parsedResponse<IAPIresponse>(response, 'data');
      return res;
    } catch (error) {
      console.log('failed: deleteAccessToken', error);
      return null;
    }
  });
